<template>
  <el-date-picker v-model="parsedValue" v-bind="parsedProps" v-on="parsedListeners" />
</template>

<script>
import { DatePicker } from 'element-ui';
import { utcToLocal, localToUtc } from '@/utilities/dateCast.ts';

export default {
  name: 'UtcDatePicker',
  extends: DatePicker,
  components: {
    'el-date-picker': DatePicker
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      date: null
    };
  },
  computed: {
    parsedProps: (vm) => {
      // We filter the value props because we want to pass a custom one
      const { value, ...filteredProps } = vm.$props;

      return filteredProps;
    },
    parsedListeners: (vm) => {
      // We filter the input and change handlers because we need control over them
      const { input, change, ...filteredListeners } = vm.$listeners;

      return filteredListeners;
    },
    parsedValue: {
      get() {
        return (this.value) ? utcToLocal(this.value) : null;
      },
      set(newValue) {
        const emitValue = newValue ? localToUtc(newValue) : null;

        this.$emit('input', emitValue);
        this.$emit('change', emitValue);
      }
    }
  }
};
</script>
